module.exports = __webpack_public_path__ + "assets/8ec893c082fad00eeb9cc8121915b1cc.svg";